import React from 'react';
import './loading.css';

const default_style = {
    position: 'absolute',
    top: '0px',
    bottom: '0px',
    left: '0px',
    right: '0px',
    margin: 'auto',
    height: '40px',
    width: '40px',
};

function Loading(props) {
    const style = { ...default_style, ...props };
    return (
        <div>
            <img alt="loading..." style={style} src="https://storage.googleapis.com/tech-cdn.pubgame.tw/pg-assets/images/loading.gif" />
        </div>
    );
}

export default Loading;


// WEBPACK FOOTER //
// ./src/components/loading.jsx